import { render, staticRenderFns } from "./RoomPolicies.vue?vue&type=template&id=37ad07ed&scoped=true&"
import script from "./RoomPolicies.vue?vue&type=script&lang=ts&"
export * from "./RoomPolicies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ad07ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37ad07ed')) {
      api.createRecord('37ad07ed', component.options)
    } else {
      api.reload('37ad07ed', component.options)
    }
    module.hot.accept("./RoomPolicies.vue?vue&type=template&id=37ad07ed&scoped=true&", function () {
      api.rerender('37ad07ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/rooms/room/RoomPolicies.vue"
export default component.exports